import { render } from "./VerifyOauth.vue?vue&type=template&id=58e1123c"
import script from "./VerifyOauth.vue?vue&type=script&lang=js"
export * from "./VerifyOauth.vue?vue&type=script&lang=js"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__